"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MASK_CHARACTER = exports.TextFieldType = void 0;
var TextFieldType;
(function (TextFieldType) {
    TextFieldType["TEXT"] = "text";
    TextFieldType["PASSWORD"] = "password";
    TextFieldType["NUMBER"] = "number";
    TextFieldType["EMAIL"] = "email";
    TextFieldType["DATE"] = "date";
    TextFieldType["INTEGER"] = "integer";
    TextFieldType["TEL"] = "tel";
    TextFieldType["HIDDEN"] = "hidden";
    TextFieldType["NUMERIC_PASSWORD"] = "numeric";
})(TextFieldType = exports.TextFieldType || (exports.TextFieldType = {}));
var MASK_CHARACTER;
(function (MASK_CHARACTER) {
    MASK_CHARACTER["DEFAULT"] = "\u2022";
})(MASK_CHARACTER = exports.MASK_CHARACTER || (exports.MASK_CHARACTER = {}));
//# sourceMappingURL=TextFieldProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TextField/TextFieldProps.js
// module id = 176
// module chunks = 8